// Three defining characteristics of TSF — icon components
export function IconGrowingTogether() {
  return <img src="assets/icons/fed-growing.png" alt="" className="fed-trait-icon" />;
}

export function IconAutonomy() {
  return <img src="assets/icons/fed-autonomy.png" alt="" className="fed-trait-icon" />;
}

export function IconSupport() {
  return <img src="assets/icons/fed-support.png" alt="" className="fed-trait-icon" />;
}

export const FED_ICONS = {
  growing: IconGrowingTogether,
  autonomy: IconAutonomy,
  support: IconSupport,
} as const;
